<ng-container *transloco="let translate">
  <h2 mat-dialog-title>
    {{ translate(data.title) }}
  </h2>
  <mat-dialog-content>
    <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
      <mat-label>{{ translate(data.placeholder) }}</mat-label>
      <input matInput [autocomplete]="'off'" [formControl]="formControl" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button [mat-dialog-close]="">
      {{ translate('CANCEL') }}
    </button>

    <button
      mat-flat-button
      [disabled]="!formControl.value"
      [mat-dialog-close]="formControl.value"
      color="primary">
      {{ translate('CONFIRM') }}
    </button>
  </mat-dialog-actions>
</ng-container>
